import SimCardDownloadOutlined from '@mui/icons-material/SimCardDownloadOutlined';
import { IconButton, Tooltip } from '@mui/material';

export function UserManualDownload() {
    return (
        <Tooltip title='Download User Manual'>
            <IconButton
                sx={{ color: 'common.white' }}
                LinkComponent={'a'}
                href='/Drive_Apps_User_Guide_2025.pdf'
                download
                target='_blank'
            >
                <SimCardDownloadOutlined />
            </IconButton>
        </Tooltip>
    );
}
